import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Marco Rossi',
  city: 'Milano'
}, {
  name: 'Giulia Bianchi',
  city: 'Roma'
}, {
  name: 'Alessandro Ferrari',
  city: 'Napoli'
}, {
  name: 'Francesca Romano',
  city: 'Torino'
}, {
  name: 'Luca Colombo',
  city: 'Bologna'
}, {
  name: 'Chiara Ricci',
  city: 'Firenze'
}, {
  name: 'Matteo Marino',
  city: 'Palermo'
}, {
  name: 'Sara Greco',
  city: 'Genova'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    // Hide after 6 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next one after 12-20 seconds
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-244">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-4 left-4 sm:bottom-8 sm:left-8 z-50 max-w-[300px] w-full" data-id="element-245">
          <div className="bg-brand-card border border-brand-orange/50 rounded-xl p-4 shadow-[0_0_20px_rgba(220,38,38,0.2)] relative overflow-hidden group" data-id="element-246">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-amber" data-id="element-247" />

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-white" data-id="element-248">
              <XIcon className="w-4 h-4" data-id="element-249" />
            </button>

            <div className="flex items-center gap-3" data-id="element-250">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-orange to-brand-amber flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-251">
                {currentBuyer.name.charAt(0)}
              </div>
              <div data-id="element-252">
                <p className="text-sm text-gray-200 font-medium leading-tight" data-id="element-253">
                  <span className="font-bold text-brand-cream" data-id="element-254">
                    {currentBuyer.name}
                  </span>{' '}
                  aus {currentBuyer.city}, Italien hat gerade dieses digitale
                  Buch gekauft
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-255">
                  <span className="flex items-center gap-1 text-xs text-green-400 font-bold" data-id="element-256">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-257" />
                    Verifiziert
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-258">
                    vor {timeAgo} Minuten
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}